import { render, staticRenderFns } from "./SmsCheckBlock.vue?vue&type=template&id=6cdeb766&scoped=true&"
import script from "./SmsCheckBlock.vue?vue&type=script&lang=js&"
export * from "./SmsCheckBlock.vue?vue&type=script&lang=js&"
import style0 from "./SmsCheckBlock.vue?vue&type=style&index=0&id=6cdeb766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdeb766",
  null
  
)

export default component.exports